import { sortBy } from '../../utils';

export const adaptBranchesToSelector = (data) => {
    const x = data.map(({ branchId, branch }) => ({ id: branchId, name: branch }));
    return sortBy(x);
};
export const adaptDoctorsToSelector = (data) => {
    const x = data.map(({ fullName, doctorId }) => ({
        id: doctorId,
        name: fullName,
    }));
    return sortBy(x);
};

export const getSpecializationsFromDoctors = doctors => doctors.reduce((acc, item) => {
    if (acc.some(({ specialityId }) => specialityId === item.specialityId)) {
        return acc;
    }
    return [ ...acc, item ];
}, []);

export const adaptSpecializationsToSelector = (data) => {
    const x = data.map(({ specialityId, specialityName }) => ({
        id: specialityId,
        name: specialityName || `mocked-name_${specialityId}`,
    }));
    return sortBy(x);
};
export const filterDoctorsBySelectedBranch = (doctors, branchId) => doctors.filter(({ branches }) => branches.some(_branchId => `${branchId}` === `${_branchId}`));
export const filterDoctorsBySelectedSpecialization = (doctors, specializationId) => doctors.filter(({ specialityId }) => `${specialityId}` === `${specializationId}`);
export const filterDoctorsForChild = (doctors, forChild, childrenAge = -1) => doctors.filter((doctor) => {
    if (!forChild) {
        return true;
    }
    if (doctor.children !== true) {
        return false;
    }
    const age = Number(childrenAge);
    return age === -1 || (
        age >= (doctor.children_age ?? 0) && age <= (doctor.children_age_to ?? 18)
    );
});
export const findDoctorById = (doctors, doctorId) => doctors.find(({ doctorId: _doctorId }) => `${_doctorId}` === `${doctorId}`);
